module.exports = __webpack_public_path__ + "img/145-ukraine.2243c41f.svg";